var map = {
	"./HalloTaxiStern_Icon.png": 8196,
	"./HalloTaxiStern_Logo.png": 4354,
	"./HalloTaxiStern_Schriftzug.png": 1036,
	"./NextCab_Fahrzeug.png": 4904,
	"./NextCab_Schriftzug.png": 957,
	"./taxi-map.jpg": 545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;